import {
  GeojsonApi,
  Layer,
  LayerLayerTypeEnum,
  MapapiApi,
  TableapiApi,
} from '@datum-group/isogd-openapi/lib';

export interface Query {
  _search?: string;
  _limit?: number;
  _page: number;
  _page_size: number;
  _offset?: number;
}

export enum NodeStatus {
  loading = 'loading',
  loaded = 'loaded',
  notLoaded = 'notLoaded',
}
export interface Node {
  name: string;
  childrenStatus: NodeStatus;
  description: string | undefined;
  layer?: Layer;
  parent?: Node;
  children?: Node[];
  error?: string;
}

export interface TreeContext {
  tableDefaultFilter?: Partial<Query>;
}

export interface APILayerGroup extends Layer {
  layer_type: LayerLayerTypeEnum.LayersGroup;
}

export interface APILayer extends Layer {
  layer_type: Exclude<LayerLayerTypeEnum, LayerLayerTypeEnum.LayersGroup>;
}

export interface APITableLayer extends Layer {
  layer_type: LayerLayerTypeEnum.Table;
  data_source: string;
}

export interface TreeServices {
  table: TableapiApi;
  map: MapapiApi;
  records: GeojsonApi;
}
